import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import { ApolloProvider } from 'react-apollo';
import { Router, Route, IndexRedirect, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import ReactGA from 'react-ga';
import { rootReducer, client } from '../reducers/index';
import googleAnalytics from '../api/googleAnalytics';
// Components
import AppContainer from '../containers/AppContainer';
import Agenda from '../components/screens/agenda/Agenda';
import Exhibitors from '../components/screens/exhibitors/Exhibitors';
import Floorplan from '../components/screens/floorplan/Floorplan';
import MediaPartners from '../components/screens/mediaPartners/MediaPartners';
import NotFound from '../components/screens/notFound/NotFound';
import Personalities from '../components/screens/personalities/Personalities';
import RoundTables from '../components/screens/roundTables/RoundTables';


const initialState = {
  localeSelector: localStorage.getItem('locale') || 'pt', // eslint-disable-line no-undef
};

const store = createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(client.middleware()),
    window.devToolsExtension ? window.devToolsExtension() : f => f // eslint-disable-line no-undef
  )
);

const history = syncHistoryWithStore(browserHistory, store);

ReactGA.initialize(googleAnalytics); // Google Analytics

const loadPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
};

const Routes = () => {
  return (
    <ApolloProvider store={store} client={client}>
      <Router onUpdate={loadPageView} history={history}>
        <Route path="/" component={AppContainer}>
          <IndexRedirect to="/pt/expositores" />

          <Route path="/en/agenda" component={Agenda} />
          <Route path="/es/agenda" component={Agenda} />
          <Route path="/pt/agenda" component={Agenda} />

          <Route path="/en/exhibitors(/:id)" component={Exhibitors} />
          <Route path="/es/exponedores(/:id)" component={Exhibitors} />
          <Route path="/pt/expositores(/:id)" component={Exhibitors} />

          <Route path="/en/floorplan" component={Floorplan} />
          <Route path="/es/floorplan" component={Floorplan} />
          <Route path="/pt/floorplan" component={Floorplan} />

          <Route path="/en/media-partners(/:id)" component={MediaPartners} />
          <Route path="/es/media-partners(/:id)" component={MediaPartners} />
          <Route path="/pt/media-partners(/:id)" component={MediaPartners} />

          <Route path="/en/personalities" component={Personalities} />
          <Route path="/es/personalidades" component={Personalities} />
          <Route path="/pt/personalidades" component={Personalities} />

          <Route path="/en/round-tables(/:id)" component={RoundTables} />
          <Route path="/es/paneles(/:id)" component={RoundTables} />
          <Route path="/pt/paineis(/:id)" component={RoundTables} />
        </Route>
        <Route path="*" component={NotFound} />
      </Router>
    </ApolloProvider>
  );
};

export default Routes;



/** WEBPACK FOOTER **
 ** ./src/api/Routes.js
 **/